// extracted by mini-css-extract-plugin
export var standaloneTable = "_ec-0";
export var standaloneTableWithBodyFill = "_ec-1";
export var withExtraHeader = "_ec-2";